module.exports = __webpack_public_path__ + "static/shop-ab75b27e04d34150a25b3183bae18a19.png";